// Polyfill for require() in Vite/ESM environment
// This allows legacy require() calls to work in the browser

import moment from "moment";
import $ from "jquery";

// Make moment and jQuery available globally for libraries that expect them
if (typeof window !== "undefined") {
  window.moment = moment;
  window.jQuery = $;
  window.$ = $;

  if (typeof window.require === "undefined") {
    window.require = function (module) {
      // For now, return empty object for server-side modules like 'https'
      if (
        module === "https" ||
        module === "http" ||
        module === "fs" ||
        module === "path"
      ) {
        return {};
      }
      if (module === "moment") {
        return moment;
      }
      if (module === "jquery") {
        return $;
      }
      throw new Error(
        `Module "${module}" not found. Please convert require() to import.`
      );
    };
  }
}
